<template>
  <div class="profile_info" v-if="hasUser">
    <v-flex xs11 class="profile_info-title">
      <h1>Account info</h1>
    </v-flex>
    <v-flex xs11 class="profile_info-table">
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr v-for="item in userData" :key="item.name">
              <td>{{ item.name }}</td>
              <td>{{ item.value }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-flex>
  </div>
  <div v-else>
    No current user
  </div>
</template>
<script>
//TODO Create normal alert for not current user situation
import { mapGetters } from "vuex";

export default {
  name: "ProfileInfo",
  computed: {
    ...mapGetters(["user", "hasUser", "categoryValue"]),
    countryList() {
      if (this.categoryValue.edges) {
        return this.categoryValue.edges.filter(
          category => category.node.category.catName === "COUNTRY_LIST"
        );
      } else {
        return [];
      }
    },
    getUserCountry() {
      if (this.countryList.length > 0) {
        return this.countryList.filter(
          c => +c.node.valId === +this.user.country
        )[0].node.valName;
      } else {
        return "Loading...";
      }
    },
    userData: {
      get() {
        if (this.hasUser) {
          return [
            {
              name: "User id",
              value: this.user.userId
            },
            {
              name: "User name",
              value: this.user.userName
            },
            {
              name: "User email",
              value: this.user.userEmail
            },
            {
              name: "User birth date",
              value: this.user.birthDate
            },
            {
              name: "Create account date",
              value: this.user.createDate
            },
            {
              name: "Country",
              value: this.getUserCountry
            },
            {
              name: "Gender",
              value: this.user.gender
            },
            {
              name: "Language",
              value: this.user.language
            },
            {
              name: "State",
              value: this.user.state
            },
            {
              name: "Role",
              value: this.user.role
            }
          ];
        } else {
          return [];
        }
      },
      set(newValue) {
        console.log(newValue);
      }
    }
  }
};
</script>
<style lang="scss">
.profile {
  &_info {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &_info-title {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  &_info-table {
    width: 100%;
  }
}
</style>
